import { departments } from './patient';
import {
  BedRounded,
  FmdGood,
  Groups2,
  HealthAndSafety,
  Hub,
  Map,
  PeopleRounded,
  SettingsRounded,
} from "@mui/icons-material";

import { userRoles } from "./user";
import RoutingList from "../utils/RoutingList";

export const allMenus = {
  admission: {
    create: {
      icon: Groups2,
      label: "Admission Request",
      route: RoutingList?.patientAdmission?.create,
    },
    nav: {
      icon: Groups2,
      label: "Admission Request",
      route: RoutingList?.patientAdmission?.index,
    },
  },
  referral: {
    create: {
      icon: Groups2,
      label: "Re-Referral",
      route: RoutingList?.referral?.create,
    },
    nav: {
      icon: Groups2,
      label: "Re-Referral",
      route: RoutingList?.referral?.index,
    },
  },
  user: {
    create: {
      icon: PeopleRounded,
      label: "User",
      route: RoutingList?.user?.create,
    },
    nav: {
      icon: PeopleRounded,
      label: "User",
      route: RoutingList?.user?.index,
    },
  },
  district: {
    create: {
      icon: Map,
      label: "District",
      route: RoutingList?.district.index,
    },
    nav: {
      icon: Map,
      label: "District",
      route: RoutingList?.district.index,
    },
  },
  bedStatus: {
    nav: {
      icon: BedRounded,
      label: "Bed Status",
      route: RoutingList.bedStatus.index,
    },
  },
  disease: {
    nav: {
      icon: HealthAndSafety,
      label: "Treatment",
      route: RoutingList.disease.index,
    },
  },
  department: {
    nav: {
      icon: Hub,
      label: "Department",
      route: RoutingList.department.index,
    },
  },
  setting: {
    nav: {
      icon: SettingsRounded,
      label: "Settings",
      route: RoutingList.settings.index,
    },
  },
};

const MENU = {
  nav: {
    [userRoles.SURGEON]: [allMenus?.admission?.nav, allMenus?.setting?.nav],
    [userRoles.D_C]: [
      allMenus?.admission?.nav,
      allMenus.bedStatus.nav,
      allMenus?.setting?.nav,
    ],
    [userRoles.STAFF]: [
      allMenus?.admission?.nav,
      allMenus.bedStatus.nav,
      allMenus?.setting?.nav,
    ],
    [userRoles.SUPER_ADMIN]: [
      allMenus?.admission?.nav,
      allMenus?.user?.nav,
      allMenus.bedStatus.nav,
      // allMenus?.district?.nav,
      allMenus?.department?.nav,
      allMenus?.disease?.nav,
      allMenus?.setting?.nav,
    ],
  },
  create: {
    [userRoles.SURGEON]: [allMenus?.admission?.create],
    [userRoles.D_C]: [],
    [userRoles.STAFF]: [],
    [userRoles.SUPER_ADMIN]: [
      allMenus?.admission?.create,
      allMenus?.user?.create,
      allMenus?.referral?.create,
      // allMenus?.district?.create,
    ],
  },
};

export default MENU;
